import React, { Component, PropTypes } from 'react';
import { geti18n } from '../../../../utils';
import VehicleImage from '../../../../components/VehicleImage';
import Disclaimer from '../../../../components/Disclaimer';
import {
  StyledVehiclePrice,
  StyledPriceMeta,
  StyledVehicleBoxButton,
  StyledVehicleBox,
  StyledActionButton
} from './infiniti-styles';

class InfinitiVehicleTile extends Component {
  static propTypes = {
    modelLineCode: PropTypes.string.isRequired,
    year: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    startingPrice: PropTypes.string.isRequired,
    onSelect: PropTypes.func.isRequired,
    buttonText: PropTypes.string.isRequired,
    startingAtText: PropTypes.string,
    msrpDisclaimer: PropTypes.string
  }
  static defaultProps = {
    buttonText: geti18n('vehicleGrid.estimateButton'),
    startingAtText: geti18n('vehicleGrid.startingAt'),
    msrpDisclaimer: geti18n('vehicleGrid.vehicleMSRPDisclaimer')
  }
  constructor() {
    super();
    this.selectVehicle = this.selectVehicle.bind(this);
  }
  selectVehicle(context) {
    const { onSelect, modelLineCode } = this.props;
    onSelect(modelLineCode, context);
  }
  render() {
    const {
        modelLineCode,
        year,
        name,
        startingPrice,
        buttonText,
        startingAtText,
        msrpDisclaimer
    } = this.props;
    return (
      <StyledVehicleBox className="medium-6 large-4 columns vehicle-box">
        <h3 className="st-heading-third">{year}</h3>
        <h3 className="full-vehicle-name st-vehicle-name" dangerouslySetInnerHTML={{ __html: name }} />
        <StyledVehicleBoxButton onClick={() => { this.selectVehicle('IMAGE-TILE') }}>
          <VehicleImage modelLineCode={modelLineCode} />
        </StyledVehicleBoxButton>
        <StyledPriceMeta className="column">
          <StyledVehiclePrice>
            <span className="heading-third"> {startingAtText} {startingPrice}
              <Disclaimer>
                {msrpDisclaimer}
              </Disclaimer>
            </span>
          </StyledVehiclePrice>
        </StyledPriceMeta>
        <div className="action-buttons">
          <StyledActionButton role="button" onClick={() => { this.selectVehicle('ESTIMATE-BUTTON') }} className="button expanded hollow large" >
            { buttonText }
          </StyledActionButton>
        </div>
      </StyledVehicleBox>
    );
  }
}

export default InfinitiVehicleTile



/** WEBPACK FOOTER **
 ** ./src/pages/ModelLineSelect/VehicleGrid/VehicleTile/infiniti.js
 **/